// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"865b48ae","83":"865b48ae","329":"55d7cea5","392":"865b48ae","510":"865b48ae","666":"865b48ae","945":"865b48ae"}[chunkId] + ".chunk.css";
};